import { isEmpty } from 'lodash';
import { DEFAULT_LANGUAGES_ORGIDS_FIELD_NAME, ENABLE_MEMBERSHIP_EXPITRATION_ORGIDS_LISTFIELD_NAME, ENABLE_MEMBERSHIP_EXPITRATION_FIELD_NAME, GOOGLE_TAG_MANAGER_CODE_FIELD_KEY, ENABLE_MEMBERSHIP_EXPITRATION_SITEIDS_LISTFIELD_NAME, IS_ASHEVILLE_PLAY_FIELD_NAME, ASHEVILLE_PLAY_GOOGLE_TAG_MANAGER_ID_FIELD_NAME, PRIVACY_POLICY_EXCLUSIVE_ORGIDS_LISTFIELD_NAME, DISPLAY_MERGE_HISTORY_TABS_FIELD_NAME, DISPLAY_MERGE_HISTORY_TABS_ORGIDS_LISTFIELD_NAME, DISPLAY_MERGE_HISTORY_TABS_SITEIDS_LISTFIELD_NAME, USE_PREQUOTE_SEARCH_FIELD_NAME, WEEKLY_SPECIALS_HASH_ORGIDS_LISTFIELD_NAME, WEEKLY_SPECIALS_HASH_SITEIDS_LISTFIELD_NAME, WEEKLY_SPECIALS_HASH_FIELD_NAME, RSI_WEEKLY_SPECIALS_HASH_FIELD_KEY, CARS_SHARE_COMPARE_FIELD_NAME, CARS_SHARE_COMPARE_ORGIDS_LISTFIELD_NAME, CARS_SHARE_COMPARE_SITEIDS_LISTFIELD_NAME, DISPLAY_PUBLIC_PRICE_B2C_SEARCH_FIELD_NAME, DISPLAY_PUBLIC_PRICE_B2C_DETAILS_FIELD_NAME, DISPLAY_PUBLIC_PRICE_B2C_BOOKING_FIELD_NAME, DISPLAY_SUPPLIER_PUBLIC_PRICE_B2C_FIELD_NAME, DISPLAY_SHARE_COMPARE_HOTELS_FIELD_NAME, DISPLAY_SHARE_COMPARE_CONDOS_FIELD_NAME, DISPLAY_SHARE_COMPARE_CARS_FIELD_NAME, WIDGET_LOGOOUT_REDIRECT_FIELD_KEY, ALLOW_LOGIN_TOKEN_PRIVATEWITHLOGIN_FIELD_NAME, POINTS_BASED_CLUB_FIELD_NAME, DISPLAY_RSI_CLUB_CHAT_FIELD_NAME, DISPLAY_RSI_CLUB_CHAT_SITEIDS_LISTFIELD_NAME, DISPLAY_RSI_CLUB_CHAT_ORGIDS_LISTFIELD_NAME, EXCLUDE_CONTACT_INFORMATION_RSI_FIELD_NAME, EXCLUDE_CONTACT_INFORMATION_RSI_ORGIDS_LISTFIELD_NAME, EXCLUDE_CONTACT_INFORMATION_RSI_SITEIDS_LISTFIELD_NAME, ENABLE_WALLET_REWARD_FIELD_NAME,
  REWARD_WALLET_PRIORITY_FIELD_NAME,
  DISABLE_NEARBY_RESULTS_FIELD_NAME,
  isRewardWalletPriority,
} from '@share/common-types';

import {
  HAS_PUBLIC_WITH_FIXED_TOKEN_FIELD_NAME,
  HOME_PAGE_TEMPLATE_FIELD_KEY,
  PUBLIC_WITH_FIXED_REDIRECT_FIELD_NAME,
  PUBLIC_WITH_FIXED_TOKEN_FIELD_NAME,
  RSI_HOME_TEMPLATE,
  ENABLE_WALLET_FIELD_NAME,
  WALLET_PERCENTAGE_FIELD_KEY,
  WALLET_EXPIRATION_NUMBER_FIELD_KEY,
  WALLET_EXPIRATION_PERIOD_FIELD_KEY,
  DISABLE_NEW_TAB_FIELD_NAME,
  FORCE_MEMBER_FIELD_KEY,
  DISABLE_HOMES_FIELD_NAME,
  DISABLE_HOMES_REDIRECT_FIELD_NAME,
  DISABLE_SIGN_IN_FIELD_NAME,
  DISABLE_SIGN_IN_REDIRECT_FIELD_NAME,
  FORCE_IFRAME_FIELD_NAME,
  TOKEN_FROM_URL_FIELD_KEY,
  WALLET_EXTERNAL_FIELD_KEY,
  WALLET_CLIENT_CASH_NAME_FIELD_KEY,
  WALLET_NO_DECIMALS_FIELD_KEY,
  WALLET_USE_SLIDER_FIELD_KEY,
  WALLET_NO_MORE_EARNINGS_FIELD_KEY,
  BUTTONS_COLOR_FIELD_KEY,
  WALLET_SLIDER_ON_SEARCH_FIELD_KEY,
  TOKEN_PROFILE_FIELD_KEY,
  FORCE_DISABLE_VACATION_RENTALS_FIELD_NAME,
  FORCE_FOOTER_VERTICAL_FIELD_KEY,
  BREAKDOWN_TAXES_FIELD_NAME,
  FEATURED_DESTINATIONS_FIELD_KEY,
  WALLET_EXTERNAL_PROFILE_FIELD_KEY,
  TRAVEL_AGENT_PRO_FORCE_IMPERSONATE_FIELD_NAME,
  TRAVEL_AGENT_PRO_DISABLE_IMPERSONATE_FIELD_NAME,
  DISABLE_LANGUAGES_FIELD_NAME,
  DISABLE_CURRENCIES_FIELD_NAME,
  WALLET_HIDE_AMOUNT_FIELD_KEY,
  WALLET_DISPLAY_B2C_SAVINGS_FIELD_KEY,
  WALLET_DISPLAY_MESSAGE_GET_MORE_CLIENT_CASH_FIELD_KEY,
  DISPLAY_CONTACT_SECTION_FIELD_NAME,
  DISPLAY_TRUSTED_BRANDS_SECTION_FIELD_NAME,
  BACKGROUND_COLOR_FIELD_KEY,
  SEARCH_ICONS_COLOR_FIELD_KEY,
  ACCOUNT_MINSAVING_FIELD_NAME,
  DISPLAY_GETAWAYS_HOME_HOTELS_SLIDER_FIELD_NAME,
  DISPLAY_GETAWAYS_HOME_CONDOS_SLIDER_FIELD_NAME,
  CARS_SEARCH_MESSAGE_FIELD_KEY,
  CARS_SEARCH_TITLE_FIELD_KEY,
  CARS_BACKGROUND_PHOTO_FIELD_KEY,
  HIDE_THINGS_MATTER_SECTION_FIELD_NAME,
  CARS_DISPLAY_TRUSTED_BRANDS_FIELD_KEY,
  ENABLE_INSURANCE_FIELD_NAME,
  FOOTER_BACKGROUND_COLOR_FIELD_KEY,
  FOOTER_FONTS_COLOR_FIELD_KEY,
  LOGO_FIELD_KEY,
  DISABLE_DOWNLOAD_VOUCHER_CHECKOUT_FIELD_NAME,
  LEAD_TIME_EXCLUDE_USERS_FIELD_NAME,
  LEAD_TIME_EXCLUDE_USER_LIST_FIELD_NAME,
  FAVICON_FIELD_KEY,
  PAGE_TITLE_FIELD_KEY,
  RSI_MASTER_CLASS_REGISTRATION_URL_FIELD_KEY,
  DISPLAY_SPECIAL_BANNERS_RSI_FIELD_NAME,
  DISPLAY_SPECIAL_BANNERS_RSI_ORGIDS_LISTFIELD_NAME,
  DISPLAY_SPECIAL_BANNERS_RSI_SITEIDS_LISTFIELD_NAME,
  DISPLAY_TRAVEL_LEADERS_BACKGROUND_RSI_FIELD_NAME,
  DISPLAY_TRAVEL_LEADERS_BACKGROUND_RSI_ORGIDS_LISTFIELD_NAME,
  DISPLAY_TRAVEL_LEADERS_BACKGROUND_RSI_SITEIDS_LISTFIELD_NAME,
  LEVARTI_ORGIDS_FIELD_NAME,
  LOYALTY_REWARDS_TEXT_SITEID_LIST_FIELD_NAME,
  LOYALTY_REWARDS_TEXT_ORGID_LIST_FIELD_NAME,
  REMOVE_INSURANCE_RSI_FIELD_NAME,
  REMOVE_INSURANCE_RSI_ORGIDS_LISTFIELD_NAME,
  REMOVE_INSURANCE_RSI_SITEIDS_LISTFIELD_NAME,
  ENABLE_LOYALTY_REWARDS_TEXT_FIELD_NAME,
  REMOVE_AUTHORIZED_USERS_RSI_SITEIDS_LISTFIELD_NAME,
  REMOVE_AUTHORIZED_USERS_RSI_ORGIDS_LISTFIELD_NAME,
  REMOVE_AUTHORIZED_USERS_RSI_FIELD_NAME,
  REMOVE_MASTERCLASS_RSI_FIELD_NAME,
  REMOVE_MASTERCLASS_RSI_ORGIDS_LISTFIELD_NAME,
  REMOVE_MASTERCLASS_RSI_SITEIDS_LISTFIELD_NAME,
  REMOVE_MEMBERVIODES_RSI_ORGIDS_LISTFIELD_NAME,
  REMOVE_MEMBERVIODES_RSI_SITEIDS_LISTFIELD_NAME,
  REMOVE_MEMBERVIODES_RSI_FIELD_NAME,
  REMOVE_CONCIERGE_MESSAGE_RSI_FIELD_NAME,
  REMOVE_CONCIERGE_MESSAGE_RSI_SITEIDS_LISTFIELD_NAME,
  REMOVE_CONCIERGE_MESSAGE_RSI_ORGIDS_LISTFIELD_NAME,
  REMOVE_CHAT_RSI_FIELD_NAME,
  REMOVE_CHAT_RSI_ORGIDS_LISTFIELD_NAME,
  REMOVE_CHAT_RSI_SITEIDS_LISTFIELD_NAME,
  REMOVE_PRICEMATCH_RSI_FIELD_NAME,
  REMOVE_PRICEMATCH_RSI_ORGIDS_LISTFIELD_NAME,
  REMOVE_PRICEMATCH_RSI_SITEIDS_LISTFIELD_NAME,
  REMOVE_RESOURCES_RSI_FIELD_NAME,
  REMOVE_RESOURCES_RSI_ORGIDS_LISTFIELD_NAME,
  REMOVE_RESOURCES_RSI_SITEIDS_LISTFIELD_NAME,
  DISABLE_EXCLUSIVE_PRICING_TAG_VACATION_RENTALS_FIELD_KEY,
  DISABLE_SAVIGNS_TAG_VACATION_RENTALS_FIELD_KEY,
  DISPLAY_HEADER_MESSGE_FIELD_KEY,
  HEADER_MESSGE_FIELD_KEY,
  HEADER_MESSGE_COLOR_FIELD_KEY,
  DISPLAY_SAVED_MEMBERS_FIELD_NAME,
  DISPLAY_SAVED_MEMBER_RSI_ORGIDS_LISTFIELD_NAME,
  DISPLAY_SAVED_MEMBER_RSI_SITEIDS_LISTFIELD_NAME,
  RESTRICTED_VACATION_RENTALS_FIELD_KEY,
  RESTRICTED_VACATION_RENTALS_LIST_FIELD_KEY,
  PROFILES_ORGIDS_FIELD_NAME,
  HEADER_BACKGROUND_COLOR_FIELD_KEY,
  HEADER_FONTS_COLOR_FIELD_KEY,
  DISABLE_NEW_TAB_RSI_SITEIDS_LISTFIELD_NAME,
  DISABLE_NEW_TAB_RSI_ORGIDS_LISTFIELD_NAME,
  LEVARTI_MARGINATOR_FIELD_KEY,
  DISPLAY_SAVED_PROPERTIES_FIELD_NAME,
  DISPLAY_SAVED_PROPERTIES_RSI_ORGIDS_LISTFIELD_NAME,
  DISPLAY_SAVED_PROPERTIES_RSI_SITEIDS_LISTFIELD_NAME,
  BUTTONS_TEXT_COLOR_FIELD_KEY,
  SEARCH_TYPES_FIELD_KEY,
  VACATION_INSPIRATIONS_ORGIDS_FIELD_NAME,
  ENABLE_GIFT_CARD_FIELD_NAME,
  ENABLE_GIFT_CARD_SITEIDS_LISTFIELD_NAME,
  ENABLE_GIFT_CARD_ORGIDS_LISTFIELD_NAME,
  VPT_ORGIDS_FIELD_NAME,
  ROB_BAKER_FIELD_NAME,
  CONFIGURATION_SUBACCOUNTS_FIELD_NAME,
  SUNDANCE_ORGIDS_FIELD_NAME,
  HELMET_HEADER_SCRIPT_FIELD_NAME,
  HOME_TITLE_COLOR_FIELD_KEY,
  MODERN_HOME_TEMPLATE_ORGIDS_LISTFIELD_NAME,
  MODERN_HOME_TEMPLATE_SITEIDS_LISTFIELD_NAME,
  ACCOUNT_TEMPLATE_FIELD_NAME,
  TEMPLATES_ORGIDS_FIELD_NAME,
  AccountTemplateEnum,
  ENABLE_MIN_PROFIT_FIELD_NAME,
  MIN_PROFIT_FIELD_NAME,
} from '@share/common-types';
import { IAccount } from '@share/common-types';
import {
  getPreferenceFromAccount,
  getToken,
  getAccountLeadTime,
  GetNumber,
  getPreferenceFileUrlFromAccount,
  getSelectedCurrency,
} from '@share/utils';
import {
  DISPLAY_GETAWAYS_HOME_HOTELS_SECTION_FIELD_NAME,
  DISPLAY_GETAWAYS_HOME_CONDOS_SECTION_FIELD_NAME,
  DISABLE_HOTELS_SEARCH_OPTIONS_FIELD_NAME,
  TOKEN_SUB_PROFILE_FIELD_KEY,
  CONDORES_SUB_PROFILE,
  CONTACT_ASSISTANTS_FIELD_KEY,
} from '@share/common-types';
import { getAccountDateFnsLocale } from '@i18n';
import { getHasQuickFromAccountPreferences } from './quick-tabs';

export enum LoginType {
  Public = 'Public',
  PrivateWithLogin = 'PrivateWithLogin',
  PrivateWithToken = 'PrivateWithToken',
}

export const ProcessPayloadAccount = (account: IAccount) => {
  const payload = account ? { ...account } : account;
  if (payload) {
    payload.hasQuick = getHasQuickFromAccountPreferences(payload);

    const disableNewTabOpen = JSON.parse(
      getPreferenceFromAccount(payload, DISABLE_NEW_TAB_FIELD_NAME, 'false'),
    );
    const forceMemberWording = JSON.parse(
      getPreferenceFromAccount(payload, FORCE_MEMBER_FIELD_KEY, 'false'),
    );
    const enableClientCash = JSON.parse(
      getPreferenceFromAccount(payload, ENABLE_WALLET_FIELD_NAME, 'false'),
    );
    const clientCashPercentage = getPreferenceFromAccount(payload, WALLET_PERCENTAGE_FIELD_KEY);

    const levartiOrgIds = JSON.parse(
      getPreferenceFromAccount(payload, LEVARTI_ORGIDS_FIELD_NAME, '[793]'),
    );

    const disableNearbyResults = JSON.parse(
      getPreferenceFromAccount(payload, DISABLE_NEARBY_RESULTS_FIELD_NAME, 'false'),
    );

    const vacationInspirationsOrgIds = JSON.parse(
      getPreferenceFromAccount(payload, VACATION_INSPIRATIONS_ORGIDS_FIELD_NAME, '[813]'),
    );

    const vptOrgIds = JSON.parse(getPreferenceFromAccount(payload, VPT_ORGIDS_FIELD_NAME, '[644]'));

    const walletIsExternal = JSON.parse(
      getPreferenceFromAccount(payload, WALLET_EXTERNAL_FIELD_KEY, 'false'),
    );
    const forceIframe = JSON.parse(
      getPreferenceFromAccount(payload, FORCE_IFRAME_FIELD_NAME, 'false'),
    );
    const walletNoDecimals = JSON.parse(
      getPreferenceFromAccount(payload, WALLET_NO_DECIMALS_FIELD_KEY, 'false'),
    );
    const walletUseSlider = JSON.parse(
      getPreferenceFromAccount(payload, WALLET_USE_SLIDER_FIELD_KEY, 'false'),
    );
    const walletNoPassEarnings = JSON.parse(
      getPreferenceFromAccount(payload, WALLET_NO_MORE_EARNINGS_FIELD_KEY, 'false'),
    );
    const privateTokenFromUrl = JSON.parse(
      getPreferenceFromAccount(payload, TOKEN_FROM_URL_FIELD_KEY, 'false'),
    );
    const hasPublicAccessToken = JSON.parse(
      getPreferenceFromAccount(payload, HAS_PUBLIC_WITH_FIXED_TOKEN_FIELD_NAME, 'false'),
    );
    const walletHasSliderOnSearch = JSON.parse(
      getPreferenceFromAccount(payload, WALLET_SLIDER_ON_SEARCH_FIELD_KEY, 'false'),
    );
    const forceFooterVertical = JSON.parse(
      getPreferenceFromAccount(payload, FORCE_FOOTER_VERTICAL_FIELD_KEY, 'false'),
    );
    const breakdownTaxes = JSON.parse(
      getPreferenceFromAccount(payload, BREAKDOWN_TAXES_FIELD_NAME, 'false'),
    );
    const walletHideAmount = JSON.parse(
      getPreferenceFromAccount(payload, WALLET_HIDE_AMOUNT_FIELD_KEY, 'false'),
    );
    const isDisableHomes = JSON.parse(
      getPreferenceFromAccount(payload, DISABLE_HOMES_FIELD_NAME, 'false'),
    );
    const forceDisableVacationRentals = JSON.parse(
      getPreferenceFromAccount(payload, FORCE_DISABLE_VACATION_RENTALS_FIELD_NAME, 'false'),
    );
    const disableImpersonate = JSON.parse(
      getPreferenceFromAccount(payload, TRAVEL_AGENT_PRO_DISABLE_IMPERSONATE_FIELD_NAME, 'false'),
    );
    const forceImpersonate = JSON.parse(
      getPreferenceFromAccount(payload, TRAVEL_AGENT_PRO_FORCE_IMPERSONATE_FIELD_NAME, 'false'),
    );
    const walletDisplayB2CSavings = JSON.parse(
      getPreferenceFromAccount(payload, WALLET_DISPLAY_B2C_SAVINGS_FIELD_KEY, 'false'),
    );
    const walletDisplayGetMoreClientCash = JSON.parse(
      getPreferenceFromAccount(
        payload,
        WALLET_DISPLAY_MESSAGE_GET_MORE_CLIENT_CASH_FIELD_KEY,
        'false',
      ),
    );
    const disableLanguages = JSON.parse(
      getPreferenceFromAccount(payload, DISABLE_LANGUAGES_FIELD_NAME, 'false'),
    );
    const disableCurrencies = JSON.parse(
      getPreferenceFromAccount(payload, DISABLE_CURRENCIES_FIELD_NAME, 'false'),
    );
    const hasDisplayContactSection = JSON.parse(
      getPreferenceFromAccount(payload, DISPLAY_CONTACT_SECTION_FIELD_NAME, 'false'),
    );
    const hasDisplayTrustedBrandsSection = JSON.parse(
      getPreferenceFromAccount(payload, DISPLAY_TRUSTED_BRANDS_SECTION_FIELD_NAME, 'false'),
    );
    const displayGetawaysHomeHotels = JSON.parse(
      getPreferenceFromAccount(payload, DISPLAY_GETAWAYS_HOME_HOTELS_SECTION_FIELD_NAME, 'false'),
    );
    const displayGetawaysHomeHotelsSlider = JSON.parse(
      getPreferenceFromAccount(payload, DISPLAY_GETAWAYS_HOME_HOTELS_SLIDER_FIELD_NAME, 'false'),
    );
    const displayGetawaysHomeCondos = JSON.parse(
      getPreferenceFromAccount(payload, DISPLAY_GETAWAYS_HOME_CONDOS_SECTION_FIELD_NAME, 'false'),
    );
    const displayGetawaysHomeCondosSlider = JSON.parse(
      getPreferenceFromAccount(payload, DISPLAY_GETAWAYS_HOME_CONDOS_SLIDER_FIELD_NAME, 'false'),
    );
    const forceDisableHotelSearchOptions = JSON.parse(
      getPreferenceFromAccount(payload, DISABLE_HOTELS_SEARCH_OPTIONS_FIELD_NAME, 'false'),
    );
    const carsDisplayTrustedBrands = JSON.parse(
      getPreferenceFromAccount(payload, CARS_DISPLAY_TRUSTED_BRANDS_FIELD_KEY, 'false'),
    );
    const enableInsurance = JSON.parse(
      getPreferenceFromAccount(payload, ENABLE_INSURANCE_FIELD_NAME, 'false'),
    );
    const hideThingsMatterSection = JSON.parse(
      getPreferenceFromAccount(payload, HIDE_THINGS_MATTER_SECTION_FIELD_NAME, 'false'),
    );
    const disableDownloadVoucherCheckout = JSON.parse(
      getPreferenceFromAccount(payload, DISABLE_DOWNLOAD_VOUCHER_CHECKOUT_FIELD_NAME, 'false'),
    );
    const leadTimeExcludeUsers = JSON.parse(
      getPreferenceFromAccount(payload, LEAD_TIME_EXCLUDE_USERS_FIELD_NAME, 'false'),
    );
    const disableExclusivePricingTagVacationRentals = JSON.parse(
      getPreferenceFromAccount(
        payload,
        DISABLE_EXCLUSIVE_PRICING_TAG_VACATION_RENTALS_FIELD_KEY,
        'false',
      ),
    );
    const disableSavingsTagVacationRentals = JSON.parse(
      getPreferenceFromAccount(payload, DISABLE_SAVIGNS_TAG_VACATION_RENTALS_FIELD_KEY, 'false'),
    );
    const restrictedVacationRentals = JSON.parse(
      getPreferenceFromAccount(payload, RESTRICTED_VACATION_RENTALS_FIELD_KEY, 'false'),
    );

    const displayHeaderMessage = JSON.parse(
      getPreferenceFromAccount(payload, DISPLAY_HEADER_MESSGE_FIELD_KEY, 'false'),
    );
    const headerMessage = getPreferenceFromAccount(payload, HEADER_MESSGE_FIELD_KEY);
    const headerMessageColor = getPreferenceFromAccount(payload, HEADER_MESSGE_COLOR_FIELD_KEY);
    const restrictedVacationRentalsList = JSON.parse(
      getPreferenceFromAccount(payload, RESTRICTED_VACATION_RENTALS_LIST_FIELD_KEY, '[]'),
    );
    const profilesOrgIdsList = JSON.parse(
      getPreferenceFromAccount(payload, PROFILES_ORGIDS_FIELD_NAME, '[]'),
    );
    const templatesOrgIdsList = JSON.parse(
      getPreferenceFromAccount(payload, TEMPLATES_ORGIDS_FIELD_NAME, '[]'),
    );
    const saverRuleProfitsOrgIdsList = JSON.parse(
      getPreferenceFromAccount(payload, ROB_BAKER_FIELD_NAME, '[]'),
    );
    const configurationSubaccountsList = JSON.parse(
      getPreferenceFromAccount(payload, CONFIGURATION_SUBACCOUNTS_FIELD_NAME, '[]'),
    );
    const defaultLanguagesOrgIdsList = JSON.parse(
      getPreferenceFromAccount(payload, DEFAULT_LANGUAGES_ORGIDS_FIELD_NAME, '[]'),
    );

    const levartiMarginatorPref = getPreferenceFromAccount(payload, LEVARTI_MARGINATOR_FIELD_KEY);
    const levartiMarginator = !isEmpty(levartiMarginatorPref)
      ? JSON.parse(levartiMarginatorPref)
      : null;

    const enableMinProfit = JSON.parse(
      getPreferenceFromAccount(payload, ENABLE_MIN_PROFIT_FIELD_NAME, 'false'),
    );
    const minProfitStr = getPreferenceFromAccount(payload, MIN_PROFIT_FIELD_NAME);
    const minProfit = minProfitStr ? Number(minProfitStr) : undefined;

    /*
    const pointsBasedClub = JSON.parse(
      getPreferenceFromAccount(payload, POINTS_BASED_CLUB_FIELD_NAME, '[]'),
    );
    */
    const pointsBasedClub = [
      { 
        organizationId: 904,
        pointsName: 'Points',
      }
    ];

    const clientCashExpirationPeriodValue = getPreferenceFromAccount(
      payload,
      WALLET_EXPIRATION_NUMBER_FIELD_KEY,
    );
    const clientCashExpirationPeriod = getPreferenceFromAccount(
      payload,
      WALLET_EXPIRATION_PERIOD_FIELD_KEY,
    );
    const disableHomesRedirect = getPreferenceFromAccount(
      payload,
      DISABLE_HOMES_REDIRECT_FIELD_NAME,
    );
    const isDisableSignIn = JSON.parse(
      getPreferenceFromAccount(payload, DISABLE_SIGN_IN_FIELD_NAME, 'false'),
    );
    const disableSignInRedirect = getPreferenceFromAccount(
      payload,
      DISABLE_SIGN_IN_REDIRECT_FIELD_NAME,
    );
    const walletClientCashName = getPreferenceFromAccount(
      payload,
      WALLET_CLIENT_CASH_NAME_FIELD_KEY,
    );
    const buttonColor = getPreferenceFromAccount(payload, BUTTONS_COLOR_FIELD_KEY);
    const buttonTextColor = getPreferenceFromAccount(payload, BUTTONS_TEXT_COLOR_FIELD_KEY);
    const walletExternalProfile = getPreferenceFromAccount(
      payload,
      WALLET_EXTERNAL_PROFILE_FIELD_KEY,
    );
    const ssoProfile = getPreferenceFromAccount(payload, TOKEN_PROFILE_FIELD_KEY);
    const homePageTemplate = getPreferenceFromAccount(payload, HOME_PAGE_TEMPLATE_FIELD_KEY);
    const accountTemplate =
      (getPreferenceFromAccount(payload, ACCOUNT_TEMPLATE_FIELD_NAME) as AccountTemplateEnum) ||
      undefined;
    const faviconPref = getPreferenceFileUrlFromAccount(payload, FAVICON_FIELD_KEY);
    const pageTitlePref = getPreferenceFromAccount(payload, PAGE_TITLE_FIELD_KEY);

    const backgroundColor = getPreferenceFromAccount(payload, BACKGROUND_COLOR_FIELD_KEY);
    const searchIconsColor = getPreferenceFromAccount(payload, SEARCH_ICONS_COLOR_FIELD_KEY);
    const searchTypes = getPreferenceFromAccount(payload, SEARCH_TYPES_FIELD_KEY);

    const homeTitleColor = getPreferenceFromAccount(
      account as IAccount,
      HOME_TITLE_COLOR_FIELD_KEY,
    );

    const enableWalletReward = JSON.parse(getPreferenceFromAccount(payload, ENABLE_WALLET_REWARD_FIELD_NAME, 'false'));
    const rewardWalletPriorityStr = getPreferenceFromAccount(payload, REWARD_WALLET_PRIORITY_FIELD_NAME);
    const rewardWalletPriority =
      rewardWalletPriorityStr && isRewardWalletPriority(rewardWalletPriorityStr) ? rewardWalletPriorityStr : undefined;

    const widgetLogoutRedirect = getPreferenceFromAccount(
      account as IAccount,
      WIDGET_LOGOOUT_REDIRECT_FIELD_KEY,
    );

    const isAshevillePlay = JSON.parse(
      getPreferenceFromAccount(payload, IS_ASHEVILLE_PLAY_FIELD_NAME, 'false'),
    );
    const ashevillePlayGoogleTagManagerId = getPreferenceFromAccount(
      payload,
      ASHEVILLE_PLAY_GOOGLE_TAG_MANAGER_ID_FIELD_NAME,
    );

    const displayMergeHistoryTabsRsi = JSON.parse(getPreferenceFromAccount(payload, DISPLAY_MERGE_HISTORY_TABS_FIELD_NAME, 'false'));
    const displayMergeHistoryTabsRsiOrgidListStr = getPreferenceFromAccount(payload, DISPLAY_MERGE_HISTORY_TABS_ORGIDS_LISTFIELD_NAME);
    const displayMergeHistoryTabsRsiSiteidListStr = getPreferenceFromAccount(payload, DISPLAY_MERGE_HISTORY_TABS_SITEIDS_LISTFIELD_NAME);

    const displaySpecialBannersRsi = JSON.parse(getPreferenceFromAccount(payload, DISPLAY_SPECIAL_BANNERS_RSI_FIELD_NAME, 'false'));
    const displayTravelLeaderBackgroundRsiOrgidListStr = getPreferenceFromAccount(payload, DISPLAY_TRAVEL_LEADERS_BACKGROUND_RSI_ORGIDS_LISTFIELD_NAME);
    const displayTravelLeaderBackgroundRsiSiteidListStr = getPreferenceFromAccount(payload, DISPLAY_TRAVEL_LEADERS_BACKGROUND_RSI_SITEIDS_LISTFIELD_NAME);

    const headerFontColor = isAshevillePlay ? '#FFFFFF' : getPreferenceFromAccount(payload, HEADER_FONTS_COLOR_FIELD_KEY);
    const headerBackgroundColor = getPreferenceFromAccount(
      payload,
      HEADER_BACKGROUND_COLOR_FIELD_KEY,
    );

    const savingsPercentageMinMinStr = getPreferenceFromAccount(
      payload,
      ACCOUNT_MINSAVING_FIELD_NAME,
    );
    const carsSearchTitle = getPreferenceFromAccount(payload, CARS_SEARCH_TITLE_FIELD_KEY);
    const carsSearchMessage = getPreferenceFromAccount(payload, CARS_SEARCH_MESSAGE_FIELD_KEY);
    const carsBackgroundImage = getPreferenceFileUrlFromAccount(
      payload,
      CARS_BACKGROUND_PHOTO_FIELD_KEY,
    );
    const leadTimeExcludeUserListStr = getPreferenceFromAccount(
      payload,
      LEAD_TIME_EXCLUDE_USER_LIST_FIELD_NAME,
    );

    const displayTravelLeaderBackgroundRsi = JSON.parse(
      getPreferenceFromAccount(payload, DISPLAY_TRAVEL_LEADERS_BACKGROUND_RSI_FIELD_NAME, 'false'),
    );
    const displaySpecialBannersRsiOrgidListStr = getPreferenceFromAccount(
      payload,
      DISPLAY_SPECIAL_BANNERS_RSI_ORGIDS_LISTFIELD_NAME,
    );
    const displaySpecialBannersRsiSiteidListStr = getPreferenceFromAccount(
      payload,
      DISPLAY_SPECIAL_BANNERS_RSI_SITEIDS_LISTFIELD_NAME,
    );

    const modernHomeTemplateOrgidListStr = getPreferenceFromAccount(
      payload,
      MODERN_HOME_TEMPLATE_ORGIDS_LISTFIELD_NAME,
    );
    const modernHomeTemplateSiteidListStr = getPreferenceFromAccount(
      payload,
      MODERN_HOME_TEMPLATE_SITEIDS_LISTFIELD_NAME,
    );

    const enableLoyaltyRewardsText = JSON.parse(
      getPreferenceFromAccount(payload, ENABLE_LOYALTY_REWARDS_TEXT_FIELD_NAME, 'false'),
    );
    const loyaltyRewardsTextSiteidListStr = getPreferenceFromAccount(
      payload,
      LOYALTY_REWARDS_TEXT_SITEID_LIST_FIELD_NAME,
    );
    const loyaltyRewardsTextOrgidListStr = getPreferenceFromAccount(
      payload,
      LOYALTY_REWARDS_TEXT_ORGID_LIST_FIELD_NAME,
    );

    const removeInsuranceRsi = JSON.parse(
      getPreferenceFromAccount(payload, REMOVE_INSURANCE_RSI_FIELD_NAME, 'false'),
    );
    const removeInsuranceRsiSiteidListStr = getPreferenceFromAccount(
      payload,
      REMOVE_INSURANCE_RSI_SITEIDS_LISTFIELD_NAME,
    );
    const removeInsuranceRsiOrgidListStr = getPreferenceFromAccount(
      payload,
      REMOVE_INSURANCE_RSI_ORGIDS_LISTFIELD_NAME,
    );

    const removeAuthorizedUsersRsi = JSON.parse(
      getPreferenceFromAccount(payload, REMOVE_AUTHORIZED_USERS_RSI_FIELD_NAME, 'false'),
    );
    const removeAuthorizedUsersRsiSiteidListStr = getPreferenceFromAccount(
      payload,
      REMOVE_AUTHORIZED_USERS_RSI_SITEIDS_LISTFIELD_NAME,
    );
    const removeAuthorizedUsersRsiOrgidListStr = getPreferenceFromAccount(
      payload,
      REMOVE_AUTHORIZED_USERS_RSI_ORGIDS_LISTFIELD_NAME,
    );

    const removeMasterclassRsi = JSON.parse(
      getPreferenceFromAccount(payload, REMOVE_MASTERCLASS_RSI_FIELD_NAME, 'false'),
    );
    const removeMasterclassRsiSiteidListStr = getPreferenceFromAccount(
      payload,
      REMOVE_MASTERCLASS_RSI_SITEIDS_LISTFIELD_NAME,
    );
    const removeMasterclasssRsiOrgidListStr = getPreferenceFromAccount(
      payload,
      REMOVE_MASTERCLASS_RSI_ORGIDS_LISTFIELD_NAME,
    );

    const removeMemberVideosRsi = JSON.parse(
      getPreferenceFromAccount(payload, REMOVE_MEMBERVIODES_RSI_FIELD_NAME, 'false'),
    );
    const removeMemberVideosRsiSiteidListStr = getPreferenceFromAccount(
      payload,
      REMOVE_MEMBERVIODES_RSI_SITEIDS_LISTFIELD_NAME,
    );
    const removeMemberVideosRsiOrgidListStr = getPreferenceFromAccount(
      payload,
      REMOVE_MEMBERVIODES_RSI_ORGIDS_LISTFIELD_NAME,
    );

    const removeConciergeMessageRsi = JSON.parse(
      getPreferenceFromAccount(payload, REMOVE_CONCIERGE_MESSAGE_RSI_FIELD_NAME, 'false'),
    );
    const removeConciergeMessageRsiSiteidListStr = getPreferenceFromAccount(
      payload,
      REMOVE_CONCIERGE_MESSAGE_RSI_SITEIDS_LISTFIELD_NAME,
    );
    const removeConciergeMessageRsiOrgidListStr = getPreferenceFromAccount(
      payload,
      REMOVE_CONCIERGE_MESSAGE_RSI_ORGIDS_LISTFIELD_NAME,
    );

    const removeChatRsi = JSON.parse(
      getPreferenceFromAccount(payload, REMOVE_CHAT_RSI_FIELD_NAME, 'false'),
    );
    const removeChatRsiSiteidListStr = getPreferenceFromAccount(
      payload,
      REMOVE_CHAT_RSI_SITEIDS_LISTFIELD_NAME,
    );
    const removeChatRsiOrgidListStr = getPreferenceFromAccount(
      payload,
      REMOVE_CHAT_RSI_ORGIDS_LISTFIELD_NAME,
    );

    const removePriceMatchRsi = JSON.parse(
      getPreferenceFromAccount(payload, REMOVE_PRICEMATCH_RSI_FIELD_NAME, 'false'),
    );
    const removePriceMatchRsiSiteidListStr = getPreferenceFromAccount(
      payload,
      REMOVE_PRICEMATCH_RSI_SITEIDS_LISTFIELD_NAME,
    );
    const removePriceMatchRsiOrgidListStr = getPreferenceFromAccount(
      payload,
      REMOVE_PRICEMATCH_RSI_ORGIDS_LISTFIELD_NAME,
    );

    const weeklySpecialHashEnabled = JSON.parse(getPreferenceFromAccount(payload, WEEKLY_SPECIALS_HASH_FIELD_NAME, 'false'));
    const weeklySpecialHashRsiSiteidListStr = getPreferenceFromAccount(payload, WEEKLY_SPECIALS_HASH_SITEIDS_LISTFIELD_NAME);
    const weeklySpecialHashRsiOrgidListStr = getPreferenceFromAccount(payload, WEEKLY_SPECIALS_HASH_ORGIDS_LISTFIELD_NAME);

    const carsShareCompareEnabled = JSON.parse(getPreferenceFromAccount(payload, CARS_SHARE_COMPARE_FIELD_NAME, 'false'));
    const carsShareCompareRsiSiteidListStr = getPreferenceFromAccount(payload, CARS_SHARE_COMPARE_SITEIDS_LISTFIELD_NAME);
    const carsShareCompareRsiOrgidListStr = getPreferenceFromAccount(payload, CARS_SHARE_COMPARE_ORGIDS_LISTFIELD_NAME);

    const displayRsiClubChatEnabled = JSON.parse(getPreferenceFromAccount(payload, DISPLAY_RSI_CLUB_CHAT_FIELD_NAME, 'false'));
    const displayRsiClubChatRsiSiteidListStr = getPreferenceFromAccount(payload, DISPLAY_RSI_CLUB_CHAT_SITEIDS_LISTFIELD_NAME);
    const displayRsiClubChatRsiOrgidListStr = getPreferenceFromAccount(payload, DISPLAY_RSI_CLUB_CHAT_ORGIDS_LISTFIELD_NAME);

    const excludeContactInformationRsi = JSON.parse(
      getPreferenceFromAccount(payload, EXCLUDE_CONTACT_INFORMATION_RSI_FIELD_NAME, 'false'),
    );
    const excludeContactInformationRsiSiteidListStr = getPreferenceFromAccount(
      payload,
      EXCLUDE_CONTACT_INFORMATION_RSI_SITEIDS_LISTFIELD_NAME,
    );
    const excludeContactInformationRsiOrgidListStr = getPreferenceFromAccount(
      payload,
      EXCLUDE_CONTACT_INFORMATION_RSI_ORGIDS_LISTFIELD_NAME,
    );

    const allowLoginTokenPrivateWithLogin = JSON.parse(getPreferenceFromAccount(account, ALLOW_LOGIN_TOKEN_PRIVATEWITHLOGIN_FIELD_NAME, 'false'));

    const removeResourcesRsi = JSON.parse(
      getPreferenceFromAccount(payload, REMOVE_RESOURCES_RSI_FIELD_NAME, 'false'),
    );
    const removeResourcesRsiSiteidListStr = getPreferenceFromAccount(
      payload,
      REMOVE_RESOURCES_RSI_SITEIDS_LISTFIELD_NAME,
    );
    const removeResourcesRsiOrgidListStr = getPreferenceFromAccount(
      payload,
      REMOVE_RESOURCES_RSI_ORGIDS_LISTFIELD_NAME,
    );

    const displaySavedMembers = JSON.parse(
      getPreferenceFromAccount(payload, DISPLAY_SAVED_MEMBERS_FIELD_NAME, 'false'),
    );
    const displaySavedMembersRsiSiteidListStr = getPreferenceFromAccount(
      payload,
      DISPLAY_SAVED_MEMBER_RSI_SITEIDS_LISTFIELD_NAME,
    );
    const displaySavedMembersRsiOrgidListStr = getPreferenceFromAccount(
      payload,
      DISPLAY_SAVED_MEMBER_RSI_ORGIDS_LISTFIELD_NAME,
    );

    const enableGiftCard = JSON.parse(
      getPreferenceFromAccount(payload, ENABLE_GIFT_CARD_FIELD_NAME, 'false'),
    );
    const enableGiftCardRsiSiteidListStr = getPreferenceFromAccount(
      payload,
      ENABLE_GIFT_CARD_SITEIDS_LISTFIELD_NAME,
    );
    const enableGiftCardRsiOrgidListStr = getPreferenceFromAccount(
      payload,
      ENABLE_GIFT_CARD_ORGIDS_LISTFIELD_NAME,
    );

    const privacyPolicyExclusiveOrgidListStr = getPreferenceFromAccount(
      payload,
      PRIVACY_POLICY_EXCLUSIVE_ORGIDS_LISTFIELD_NAME,
    );

    const displayMergeHistoryTabsRsiOrgidList = displayMergeHistoryTabsRsiOrgidListStr?.split(',').map((s: string) => s.trim());
    const displayMergeHistoryTabsRsiSiteidList = displayMergeHistoryTabsRsiSiteidListStr?.split(',').map((s: string) => s.trim());

    const enableMembershipExpiration = JSON.parse(
      getPreferenceFromAccount(payload, ENABLE_MEMBERSHIP_EXPITRATION_FIELD_NAME, 'false'),
    );
    const enableMembershipExpirationRsiSiteidListStr = getPreferenceFromAccount(
      payload,
      ENABLE_MEMBERSHIP_EXPITRATION_SITEIDS_LISTFIELD_NAME,
    );
    const enableMembershipExpirationRsiOrgidListStr = getPreferenceFromAccount(
      payload,
      ENABLE_MEMBERSHIP_EXPITRATION_ORGIDS_LISTFIELD_NAME,
    );

    const usePrequoteSearch = JSON.parse(getPreferenceFromAccount(payload, USE_PREQUOTE_SEARCH_FIELD_NAME, 'false'));

    const displaySavedProperties = JSON.parse(
      getPreferenceFromAccount(payload, DISPLAY_SAVED_PROPERTIES_FIELD_NAME, 'false'),
    );
    const displaySavedPropertiesRsiSiteidListStr = getPreferenceFromAccount(
      payload,
      DISPLAY_SAVED_PROPERTIES_RSI_SITEIDS_LISTFIELD_NAME,
    );
    const displaySavedPropertiesRsiOrgidListStr = getPreferenceFromAccount(
      payload,
      DISPLAY_SAVED_PROPERTIES_RSI_ORGIDS_LISTFIELD_NAME,
    );

    const displayShareCompareHotels = JSON.parse(
      getPreferenceFromAccount(payload, DISPLAY_SHARE_COMPARE_HOTELS_FIELD_NAME, 'false'),
    );
    const displayShareCompareCondos = JSON.parse(
      getPreferenceFromAccount(payload, DISPLAY_SHARE_COMPARE_CONDOS_FIELD_NAME, 'false'),
    );
    const displayShareCompareCars = JSON.parse(
      getPreferenceFromAccount(payload, DISPLAY_SHARE_COMPARE_CARS_FIELD_NAME, 'false'),
    );

    const disableNewTabOpenRsiSiteidListStr = getPreferenceFromAccount(
      payload,
      DISABLE_NEW_TAB_RSI_SITEIDS_LISTFIELD_NAME,
    );
    const disableNewTabOpenRsiOrgidListStr = getPreferenceFromAccount(
      payload,
      DISABLE_NEW_TAB_RSI_ORGIDS_LISTFIELD_NAME,
    );

    const sundanceOrgIds = JSON.parse(
      getPreferenceFromAccount(payload, SUNDANCE_ORGIDS_FIELD_NAME, '[]'),
    );

    const helmetScripts = getPreferenceFromAccount(
      payload,
      HELMET_HEADER_SCRIPT_FIELD_NAME,
      '',
    )?.split(',');

    const savingsPercentageMin =
      !savingsPercentageMinMinStr ||
      savingsPercentageMinMinStr === '0' ||
      savingsPercentageMinMinStr === 'null'
        ? 0
        : GetNumber(savingsPercentageMinMinStr);

    const leadTimeExcludeUserList = leadTimeExcludeUserListStr
      ?.split(',')
      .map((s: string) => s.trim());
    const displaySpecialBannersRsiOrgidList = displaySpecialBannersRsiOrgidListStr
      ?.split(',')
      .map((s: string) => s.trim());
    const displaySpecialBannersRsiSiteidList = displaySpecialBannersRsiSiteidListStr
      ?.split(',')
      .map((s: string) => s.trim());

    const displayTravelLeaderBackgroundRsiOrgidList = displayTravelLeaderBackgroundRsiOrgidListStr
      ?.split(',')
      .map((s: string) => s.trim());
    const displayTravelLeaderBackgroundRsiSiteidList = displayTravelLeaderBackgroundRsiSiteidListStr
      ?.split(',')
      .map((s: string) => s.trim());

    const modernHomeTemplateOrgidList = modernHomeTemplateOrgidListStr
      ?.split(',')
      .map((s: string) => s.trim());
    const modernHomeTemplateSiteidList = modernHomeTemplateSiteidListStr
      ?.split(',')
      .map((s: string) => s.trim());

    const loyaltyRewardsTextSiteidList = enableLoyaltyRewardsText
      ? loyaltyRewardsTextSiteidListStr?.split(',').map((s: string) => s.trim())
      : [];
    const loyaltyRewardsTextOrgidList = enableLoyaltyRewardsText
      ? loyaltyRewardsTextOrgidListStr?.split(',').map((s: string) => s.trim())
      : [];

    const removeInsuranceRsiSiteidList = removeInsuranceRsi
      ? removeInsuranceRsiSiteidListStr?.split(',').map((s: string) => s.trim())
      : [];
    const removeInsuranceRsiOrgidList = removeInsuranceRsi
      ? removeInsuranceRsiOrgidListStr?.split(',').map((s: string) => s.trim())
      : [];

    const removeAuthorizedUsersRsiSiteidList = removeAuthorizedUsersRsi
      ? removeAuthorizedUsersRsiSiteidListStr?.split(',').map((s: string) => s.trim())
      : [];
    const removeAuthorizedUsersRsiOrgidList = removeAuthorizedUsersRsi
      ? removeAuthorizedUsersRsiOrgidListStr?.split(',').map((s: string) => s.trim())
      : [];

    const removeMasterclassRsiSiteidList = removeMasterclassRsi
      ? removeMasterclassRsiSiteidListStr?.split(',').map((s: string) => s.trim())
      : [];
    const removeMasterclasssRsiOrgidList = removeMasterclassRsi
      ? removeMasterclasssRsiOrgidListStr?.split(',').map((s: string) => s.trim())
      : [];

    const removeMemberVideosRsiSiteidList = removeMemberVideosRsi
      ? removeMemberVideosRsiSiteidListStr?.split(',').map((s: string) => s.trim())
      : [];
    const removeMemberVideosRsiOrgidList = removeMemberVideosRsi
      ? removeMemberVideosRsiOrgidListStr?.split(',').map((s: string) => s.trim())
      : [];

    const removeConciergeMessageRsiSiteidList = removeConciergeMessageRsi
      ? removeConciergeMessageRsiSiteidListStr?.split(',').map((s: string) => s.trim())
      : [];
    const removeConciergeMessageRsiOrgidList = removeConciergeMessageRsi
      ? removeConciergeMessageRsiOrgidListStr?.split(',').map((s: string) => s.trim())
      : [];

    const removeChatRsiSiteidList = removeChatRsi
      ? removeChatRsiSiteidListStr?.split(',').map((s: string) => s.trim())
      : [];
    const removeChatRsiOrgidList = removeChatRsi
      ? removeChatRsiOrgidListStr?.split(',').map((s: string) => s.trim())
      : [];

    const removePriceMatchRsiSiteidList = removePriceMatchRsi
      ? removePriceMatchRsiSiteidListStr?.split(',').map((s: string) => s.trim())
      : [];
    const removePriceMatchRsiOrgidList = removePriceMatchRsi
      ? removePriceMatchRsiOrgidListStr?.split(',').map((s: string) => s.trim())
      : [];

    const removeResourcesRsiSiteidList = removeResourcesRsi
      ? removeResourcesRsiSiteidListStr?.split(',').map((s: string) => s.trim())
      : [];
    const removeResourcesRsiOrgidList = removeResourcesRsi
      ? removeResourcesRsiOrgidListStr?.split(',').map((s: string) => s.trim())
      : [];

    const displaySavedMembersRsiSiteidList = displaySavedMembers
      ? displaySavedMembersRsiSiteidListStr?.split(',').map((s: string) => s.trim())
      : [];
    const displaySavedMembersRsiOrgidList = displaySavedMembers
      ? displaySavedMembersRsiOrgidListStr?.split(',').map((s: string) => s.trim())
      : [];

    const displaySavedPropertiesRsiSiteidList = displaySavedProperties
      ? displaySavedPropertiesRsiSiteidListStr?.split(',').map((s: string) => s.trim())
      : [];
    const displaySavedPropertiesRsiOrgidList = displaySavedProperties
      ? displaySavedPropertiesRsiOrgidListStr?.split(',').map((s: string) => s.trim())
      : [];

    const disableNewTabOpenRsiSiteidList = disableNewTabOpen
      ? disableNewTabOpenRsiSiteidListStr?.split(',').map((s: string) => s.trim())
      : [];
    const disableNewTabOpenRsiOrgidList = disableNewTabOpen
      ? disableNewTabOpenRsiOrgidListStr?.split(',').map((s: string) => s.trim())
      : [];

    const enableGiftCardRsiSiteidList = enableGiftCard
      ? enableGiftCardRsiSiteidListStr?.split(',').map((s: string) => s.trim())
      : [];
    const enableGiftCardRsiOrgidList = enableGiftCard
      ? enableGiftCardRsiOrgidListStr?.split(',').map((s: string) => s.trim())
      : [];

    const privacyPolicyExclusiveOrgidList =
      privacyPolicyExclusiveOrgidListStr?.split(',').map((s: string) => s.trim()) || [];
    privacyPolicyExclusiveOrgidList.push('865', '820', '798');

    const enableMembershipExpirationRsiSiteidList = enableMembershipExpiration
      ? enableMembershipExpirationRsiSiteidListStr?.split(',').map((s: string) => s.trim())
      : [];
    const enableMembershipExpirationRsiOrgidList = enableMembershipExpiration
      ? enableMembershipExpirationRsiOrgidListStr?.split(',').map((s: string) => s.trim())
      : [];

    const weeklySpecialHashRsiSiteidList = weeklySpecialHashEnabled ? weeklySpecialHashRsiSiteidListStr?.split(',').map((s: string) => s.trim()) : [];
    const weeklySpecialHashRsiOrgidList = weeklySpecialHashEnabled ? weeklySpecialHashRsiOrgidListStr?.split(',').map((s: string) => s.trim()) : [];

    const carsShareCompareRsiSiteidList = carsShareCompareEnabled ? carsShareCompareRsiSiteidListStr?.split(',').map((s: string) => s.trim()) : [];
    const carsShareCompareRsiOrgidList = carsShareCompareEnabled ? carsShareCompareRsiOrgidListStr?.split(',').map((s: string) => s.trim()) : [];

    const displayRsiClubChatRsiSiteidList = displayRsiClubChatEnabled ? displayRsiClubChatRsiSiteidListStr?.split(',').map((s: string) => s.trim()) : [];
    const displayRsiClubChatRsiOrgidList = displayRsiClubChatEnabled ? displayRsiClubChatRsiOrgidListStr?.split(',').map((s: string) => s.trim()) : [];

    const excludeContactInformationRsiSiteidList = excludeContactInformationRsi
      ? excludeContactInformationRsiSiteidListStr?.split(',').map((s: string) => s.trim())
      : [];
    const excludeContactInformationRsiOrgidList = excludeContactInformationRsi
      ? excludeContactInformationRsiOrgidListStr?.split(',').map((s: string) => s.trim())
      : [];

    const locale = getAccountDateFnsLocale(payload);
    const leadTime = getAccountLeadTime(payload);

    const accessTokenDb = getPreferenceFromAccount(payload, PUBLIC_WITH_FIXED_TOKEN_FIELD_NAME);
    const accessTokenRedirect = getPreferenceFromAccount(
      payload,
      PUBLIC_WITH_FIXED_REDIRECT_FIELD_NAME,
    );

    const contactAssistantsInt = getPreferenceFromAccount(payload, CONTACT_ASSISTANTS_FIELD_KEY);
    const contactAssistants = !isEmpty(contactAssistantsInt)
      ? JSON.parse(contactAssistantsInt)
      : null;

    const ssoSubProfile = getPreferenceFromAccount(payload, TOKEN_SUB_PROFILE_FIELD_KEY);

    const footerBackgroundColorDB = getPreferenceFromAccount(
      payload,
      FOOTER_BACKGROUND_COLOR_FIELD_KEY,
    );
    const footerFontsColorDB = getPreferenceFromAccount(payload, FOOTER_FONTS_COLOR_FIELD_KEY);
    const logoDB = getPreferenceFileUrlFromAccount(payload, LOGO_FIELD_KEY);

    const googleTagManagerCode = getPreferenceFromAccount(
      payload,
      GOOGLE_TAG_MANAGER_CODE_FIELD_KEY,
    );

    const masterClassesRegistration = getPreferenceFromAccount(payload, RSI_MASTER_CLASS_REGISTRATION_URL_FIELD_KEY);
    const weeklySpecialHash = JSON.parse(getPreferenceFromAccount(payload, RSI_WEEKLY_SPECIALS_HASH_FIELD_KEY, '{}'));

    const displayPublicPriceB2CSearch = JSON.parse(getPreferenceFromAccount(payload, DISPLAY_PUBLIC_PRICE_B2C_SEARCH_FIELD_NAME, 'false'));
    const displayPublicPriceB2CDetails = JSON.parse(getPreferenceFromAccount(payload, DISPLAY_PUBLIC_PRICE_B2C_DETAILS_FIELD_NAME, 'false'));
    const displayPublicPriceB2CBooking = JSON.parse(getPreferenceFromAccount(payload, DISPLAY_PUBLIC_PRICE_B2C_BOOKING_FIELD_NAME, 'false'));
    const displaySupplierPublicPriceB2C = JSON.parse(getPreferenceFromAccount(payload, DISPLAY_SUPPLIER_PUBLIC_PRICE_B2C_FIELD_NAME, 'false'));

    const featuredDestinations = JSON.parse(
      getPreferenceFromAccount(payload, FEATURED_DESTINATIONS_FIELD_KEY, '[]'),
    );

    const currency = getSelectedCurrency(payload, true);
    const token = getToken(payload);

    const hasClientCash =
      enableClientCash &&
      !enableWalletReward &&
      !isEmpty(clientCashPercentage) &&
      (walletIsExternal ||
        (!isEmpty(clientCashExpirationPeriodValue) && !isEmpty(clientCashExpirationPeriod)));

    const isPrivateTokenAccountType = payload?.type === LoginType.PrivateWithToken;
    const isPrivateLoginAccountType = payload?.type === LoginType.PrivateWithLogin;
    const isPublicAccountType = payload?.type === LoginType.Public;

    const isCapitalVacationsMain =
      isPrivateTokenAccountType && privateTokenFromUrl && ssoProfile === 'capitalvacations';
    const isCapitalVacationsAgent =
      isPrivateLoginAccountType &&
      hasClientCash &&
      walletIsExternal &&
      walletExternalProfile === 'CapitalVacations';
    const isCapitalVacations = isCapitalVacationsMain || isCapitalVacationsAgent;

    const walletWalletSavings =
      hasClientCash && walletDisplayB2CSavings && payload?.isB2C && walletNoPassEarnings;

    const isRSITemplate = homePageTemplate === RSI_HOME_TEMPLATE;

    // For now, hardcode the initial values (29172, 273)
    // Later this will be configurable from backoffice
    const moderTemplateSiteIdOrgIdList = [{ organizationId: 738, siteId: 50697 }];

    payload.hasClientCash = hasClientCash;
    payload.pointsBasedClub = pointsBasedClub;
    payload.forceMemberWording = forceMemberWording;
    payload.clientCashPercentage = clientCashPercentage;
    payload.forceIframe = forceIframe;
    payload.disableNewTabOpen = disableNewTabOpen;
    payload.isDisableHomes = isDisableHomes;
    payload.disableHomesRedirect = disableHomesRedirect;
    payload.isDisableSignIn = isDisableSignIn;
    payload.disableSignInRedirect = disableSignInRedirect;
    payload.walletIsExternal = walletIsExternal;
    payload.walletClientCashName = isEmpty(walletClientCashName)
      ? 'Client Cash'
      : walletClientCashName;
    payload.walletNoDecimals = walletNoDecimals;
    payload.walletUseSlider = walletUseSlider;
    payload.walletNoPassEarnings = walletNoPassEarnings;
    payload.privateTokenFromUrl = privateTokenFromUrl;
    payload.buttonColor = buttonColor;
    payload.buttonTextColor = buttonTextColor;
    payload.hasPublicAccessToken = hasPublicAccessToken;
    payload.walletHasSliderOnSearch = walletHasSliderOnSearch;
    payload.ssoProfile = ssoProfile;
    payload.ssoProfile = ssoSubProfile;
    payload.isCapitalVacations = isCapitalVacations;
    payload.isCapitalVacationsMain = isCapitalVacationsMain;
    payload.isCapitalVacationsAgent = isCapitalVacationsAgent;
    payload.isCapitalVacationsCondoRes = ssoSubProfile === CONDORES_SUB_PROFILE;
    payload.forceDisableVacationRentals = forceDisableVacationRentals;
    payload.forceFooterVertical = forceFooterVertical;
    payload.breakdownTaxes = breakdownTaxes;
    payload.featuredDestinations = featuredDestinations;
    payload.walletHideAmount = walletHideAmount;
    payload.disableImpersonate = disableImpersonate;
    payload.forceImpersonate = forceImpersonate;
    payload.walletDisplayB2CSavings = walletDisplayB2CSavings;
    payload.walletWalletSavings = walletWalletSavings;
    payload.walletDisplayGetMoreClientCash = walletDisplayGetMoreClientCash;
    payload.disableLanguages = disableLanguages;
    payload.disableCurrencies = disableCurrencies;
    payload.hasDisplayContactSection = hasDisplayContactSection;
    payload.hasDisplayTrustedBrandsSection = hasDisplayTrustedBrandsSection;
    payload.homePageTemplate = homePageTemplate;
    payload.accountTemplate = accountTemplate;
    payload.isNewTemplate = accountTemplate === AccountTemplateEnum.NewTemplate;
    payload.isRSITemplate = isRSITemplate;
    payload.isAshevillePlay = isAshevillePlay;
    payload.allowLoginTokenPrivateWithLogin = allowLoginTokenPrivateWithLogin;

    payload.moderTemplateSiteIdOrgIdList = moderTemplateSiteIdOrgIdList;

    payload.ashevillePlayGoogleTagManagerId = ashevillePlayGoogleTagManagerId;

    payload.ashevillePlayLocationCode = '115506'; //ashevillePlayLocationCode get from preference;
    payload.ashevillePlayGoogleLogo = 'https://hutchapps.com/ashevilleplay/img/logo/ashevilleplay-logo-horizontal-white.svg'; //ashevillePlayGoogleLogo get from preference;
    payload.ashevillePlayGoogleLogoScroll = 'https://hutchapps.com/ashevilleplay/img/logo/ashevilleplay-logo-horizontal-color.svg'; //ashevillePlayGoogleLogoScroll get from preference;
    payload.ashevillePlayBestDeals = [
      '2969804',
      '427017',
      '486458',
      '527710',
      '527710',
      '575584',
    ]; //ashevillePlayBestDeals get from preference;
    payload.ashevillePlayTours = [
      {
        src: 'https://hutchapps.com/ashevilleplay/img/excursions/waterfall-tour.jpg',
        url: 'https://fareharbor.com/embeds/book/ashevilleplay/items/637682/calendar/2025/08/?ref=Website&flow=1408314&language=en&full-items=yes&back=https://ashevilletoursandexcursions.com/',
        title: 'Waterfall Adventure Tour',
        subTitle: 'Chase waterfalls. Find wonder.',
        options: [
          'Visit 2-3 epic Asheville waterfalls',
          'Includes a light forest hike',
          'Stories from deep in Pisgah National Forest',
          'Best for explorers, photographers, and families',
        ],
      },
      {
        src: 'https://hutchapps.com/ashevilleplay/img/excursions/blueridge-tour.jpg',
        url: 'https://fareharbor.com/embeds/book/ashevilleplay/items/637658/calendar/2025/08/?ref=Website&flow=1408314&language=en&full-items=yes&back=https://ashevilletoursandexcursions.com/',
        title: 'Blue Ridge Parkway Scenic Tour',
        subTitle: 'Breath in the Blue Ridge.',
        options: [
          'Panoramic overlooks and photo stops',
          'Hike to a hidden waterfall',
          'Learn about local wildlife',
          'Perfect for first-time visitors & nature lovers',
        ],
      },
      {
        src: 'https://hutchapps.com/ashevilleplay/img/excursions/sunrise-tour.jpg',
        url: 'https://fareharbor.com/embeds/book/ashevilleplay/items/637684/calendar/2025/08/?ref=Website&flow=1408314&full-items=yes&back=https://ashevilletoursandexcursions.com/',
        title: 'Sunrise Mountain Tour',
        subTitle: 'Golden hour. Mountain magic.',
        options: [
          'Ride out before dawn',
          'Hot coffee & peaceful vibes',
          'Catch the sunrise over Asheville, North Carolina',
          'Great for early birds, photographers and romantics',
        ],
      },
      {
        src: 'https://hutchapps.com/ashevilleplay/img/excursions/biltmore-tour.jpg',
        url: 'https://fareharbor.com/embeds/book/ashevilleplay/items/637694/calendar/2025/08/?ref=Website&flow=1408314&full-items=yes&back=https://ashevilletoursandexcursions.com/',
        title: 'History & Culture Tour',
        subTitle: 'Ride by real mountain stories.',
        options: [
          'View historic sites & scenic overlooks',
          'Hear Cherokee & settler lore',
          'Explore the culture behind the views',
          'Great for families & curious minds',
        ],
      },
      {
        src: 'https://hutchapps.com/ashevilleplay/img/excursions/offroad-tour.jpg',
        url: 'https://fareharbor.com/embeds/book/ashevilleplay/items/637686/calendar/2025/08/?ref=Website&flow=1408314&full-items=yes&back=https://ashevilletoursandexcursions.com/',
        title: 'Off-Road Backroads Tour',
        subTitle: 'Thrills, mud and mountain views.',
        options: [
          'Rugged 4x4 trails & forest backroads',
          'Explore historic homesteads',
          'Ride to 5,000+ ft peaks',
          'Great for adventurers and thrill-seekers',
        ],
      },
      {
        src: 'https://hutchapps.com/ashevilleplay/img/excursions/foliage-tour.jpg',
        url: 'https://fareharbor.com/embeds/book/ashevilleplay/items/637688/calendar/2025/09/?ref=Website&flow=1408314&full-items=yes&back=https://ashevilletoursandexcursions.com/',
        title: 'Seasonal Fall Foliage Tour',
        subTitle: 'Nature\'s grand finale in 4K.',
        options: [
          'Best leaf-peeping spots in Asheville',
          'Scenic Blue Ridge Parkway route',
          'Stops for photography & short hikes',
          'Only offered Sept-Nov, so book early!',
        ],
      },
      {
        src: 'https://hutchapps.com/ashevilleplay/img/excursions/brewery-tour.jpg',
        url: 'https://fareharbor.com/embeds/book/ashevilleplay/items/637699/calendar/2025/08/?ref=Website&flow=1408315&full-items=yes&back=https://ashevilletoursandexcursions.com/',
        title: 'The Asheville Brewery Tour',
        subTitle: 'Big wheels. Bold brews.',
        options: [
          'Visit 3-4 legendary local Asheville breweries',
          'Ride in a lit-up monster party truck',
          'Beer tastings, stories & city views',
          'Perfect for large or small groups & beer lovers',
        ],
      },
      {
        src: 'https://hutchapps.com/ashevilleplay/img/excursions/party-tour.jpg',
        url: 'https://fareharbor.com/embeds/book/ashevilleplay/items/637700/calendar/2025/08/?ref=Website&flow=1408315&full-items=yes&back=https://ashevilletoursandexcursions.com/',
        title: 'Asheville Sightseeing & Party Tour',
        subTitle: 'Wildest city tour you\'ll ever take.',
        options: [
          'Cruise past murals, landmarks & breweries',
          'Open-air party vehicle (BYOB approved)',
          'Music, fun facts & epic photo ops',
          'Ideal for celebrations & friend groups',
        ],
      },
    ]; //ashevillePlayTours get from preference;


    payload.backgroundColor = backgroundColor;
    payload.homeTitleColor = homeTitleColor;
    payload.widgetLogoutRedirect = widgetLogoutRedirect;
    payload.searchIconsColor = searchIconsColor;
    payload.leadTime = leadTime;
    payload.locale = locale;
    payload.displayGetawaysHomeHotels = displayGetawaysHomeHotels;
    payload.displayGetawaysHomeCondos = displayGetawaysHomeCondos;
    payload.forceDisableHotelSearchOptions = forceDisableHotelSearchOptions;
    payload.homePageTemplate = homePageTemplate;
    payload.accountTemplate = accountTemplate;
    payload.isNewTemplate = accountTemplate === AccountTemplateEnum.NewTemplate;
    payload.isPrivateTokenAccountType = isPrivateTokenAccountType;
    payload.isPrivateLoginAccountType = isPrivateLoginAccountType;
    payload.isPublicAccountType = isPublicAccountType;
    payload.contactAssistants = contactAssistants;
    payload.savingsPercentageMin = savingsPercentageMin;
    payload.usePrequoteSearch = usePrequoteSearch;
    payload.displayGetawaysHomeHotelsSlider = displayGetawaysHomeHotelsSlider;
    payload.displayGetawaysHomeCondosSlider = displayGetawaysHomeCondosSlider;
    payload.contactAssistants = contactAssistants;
    payload.carsSearchTitle = carsSearchTitle;
    payload.carsSearchMessage = carsSearchMessage;
    payload.carsBackgroundImage = carsBackgroundImage;
    payload.hideThingsMatterSection = hideThingsMatterSection;
    payload.carsDisplayTrustedBrands = carsDisplayTrustedBrands;
    payload.enableInsurance = enableInsurance;
    payload.hideThingsMatterSection = hideThingsMatterSection;
    payload.footerBackgroundColorDB = footerBackgroundColorDB;
    payload.footerFontsColorDB = footerFontsColorDB;
    payload.disableDownloadVoucherCheckout = disableDownloadVoucherCheckout;
    payload.logoDB = logoDB;
    payload.accessTokenDb = accessTokenDb;
    payload.accessTokenRedirect = accessTokenRedirect;
    payload.masterClassesRegistration = masterClassesRegistration;
    payload.faviconPref = faviconPref;
    payload.pageTitlePref = pageTitlePref;
    payload.currency = currency;
    payload.token = token;
    payload.leadTimeExcludeUsers = leadTimeExcludeUsers;
    payload.leadTimeExcludeUserList = leadTimeExcludeUserList;
    payload.displaySpecialBannersRsi = displaySpecialBannersRsi;
    payload.levartiOrgIds = levartiOrgIds;
    payload.vacationInspirationsOrgIds = vacationInspirationsOrgIds;
    payload.vptOrgIds = vptOrgIds;
    payload.sundanceOrgIds = sundanceOrgIds;
    payload.helmetScripts = helmetScripts;
    payload.displaySpecialBannersRsiOrgidList = displaySpecialBannersRsiOrgidList;
    payload.displaySpecialBannersRsiSiteidList = displaySpecialBannersRsiSiteidList;
    payload.displayTravelLeaderBackgroundRsi = displayTravelLeaderBackgroundRsi;
    payload.displayTravelLeaderBackgroundRsiOrgidList = displayTravelLeaderBackgroundRsiOrgidList;
    payload.displayTravelLeaderBackgroundRsiSiteidList = displayTravelLeaderBackgroundRsiSiteidList;
    payload.loyaltyRewardsTextSiteidList = loyaltyRewardsTextSiteidList;
    payload.loyaltyRewardsTextOrgidList = loyaltyRewardsTextOrgidList;
    payload.removeInsuranceRsiSiteidList = removeInsuranceRsiSiteidList;
    payload.removeInsuranceRsiOrgidList = removeInsuranceRsiOrgidList;
    payload.removeAuthorizedUsersRsiSiteidList = removeAuthorizedUsersRsiSiteidList;
    payload.removeAuthorizedUsersRsiOrgidList = removeAuthorizedUsersRsiOrgidList;
    payload.removeMasterclassRsiSiteidList = removeMasterclassRsiSiteidList;
    payload.removeMasterclasssRsiOrgidList = removeMasterclasssRsiOrgidList;
    payload.removeMemberVideosRsiSiteidList = removeMemberVideosRsiSiteidList;
    payload.removeMemberVideosRsiOrgidList = removeMemberVideosRsiOrgidList;
    payload.removeConciergeMessageRsiSiteidList = removeConciergeMessageRsiSiteidList;
    payload.removeConciergeMessageRsiOrgidList = removeConciergeMessageRsiOrgidList;
    payload.removeChatRsiSiteidList = removeChatRsiSiteidList;
    payload.removeChatRsiOrgidList = removeChatRsiOrgidList;
    payload.removePriceMatchRsiSiteidList = removePriceMatchRsiSiteidList;
    payload.removePriceMatchRsiOrgidList = removePriceMatchRsiOrgidList;
    payload.removeResourcesRsiSiteidList = removeResourcesRsiSiteidList;
    payload.removeResourcesRsiOrgidList = removeResourcesRsiOrgidList;
    payload.disableExclusivePricingTagVacationRentals = disableExclusivePricingTagVacationRentals;
    payload.disableSavingsTagVacationRentals = disableSavingsTagVacationRentals;
    payload.displaySavedMembers = displaySavedMembers;
    payload.displaySavedMembersRsiSiteidList = displaySavedMembersRsiSiteidList;
    payload.displaySavedMembersRsiOrgidList = displaySavedMembersRsiOrgidList;
    payload.displaySavedProperties = displaySavedProperties;
    payload.displaySavedPropertiesRsiSiteidList = displaySavedPropertiesRsiSiteidList;
    payload.displaySavedPropertiesRsiOrgidList = displaySavedPropertiesRsiOrgidList;
    payload.displayHeaderMessage = displayHeaderMessage;
    payload.headerMessage = headerMessage;
    payload.headerMessageColor = headerMessageColor;
    payload.searchTypes = searchTypes;
    payload.restrictedVacationRentals = restrictedVacationRentals;
    payload.restrictedVacationRentalsList = restrictedVacationRentalsList;
    payload.profilesOrgIdsList = profilesOrgIdsList;
    payload.templatesOrgIdsList = templatesOrgIdsList;
    payload.saverRuleProfitsOrgIdsList = saverRuleProfitsOrgIdsList;
    payload.configurationSubaccountsList = configurationSubaccountsList;
    payload.defaultLanguagesOrgIdsList = defaultLanguagesOrgIdsList;
    payload.headerFontColor = headerFontColor;
    payload.headerBackgroundColor = headerBackgroundColor;
    payload.disableNewTabOpenRsiSiteidList = disableNewTabOpenRsiSiteidList;
    payload.disableNewTabOpenRsiOrgidList = disableNewTabOpenRsiOrgidList;
    payload.levartiMarginator = levartiMarginator;
    payload.enableMinProfit = enableMinProfit;
    payload.minProfit = minProfit;
    payload.enableGiftCard = enableGiftCard;
    payload.enableGiftCardRsiSiteidList = enableGiftCardRsiSiteidList;
    payload.enableGiftCardRsiOrgidList = enableGiftCardRsiOrgidList;
    payload.enableMembershipExpiration = enableMembershipExpiration;
    payload.enableMembershipExpirationRsiSiteidList = enableMembershipExpirationRsiSiteidList;
    payload.enableMembershipExpirationRsiOrgidList = enableMembershipExpirationRsiOrgidList;
    payload.weeklySpecialHash = weeklySpecialHash;
    payload.weeklySpecialHashEnabled = weeklySpecialHashEnabled;
    payload.weeklySpecialHashRsiSiteidList = weeklySpecialHashRsiSiteidList;
    payload.weeklySpecialHashRsiOrgidList = weeklySpecialHashRsiOrgidList;
    payload.carsShareCompareEnabled = carsShareCompareEnabled;
    payload.carsShareCompareRsiSiteidList = carsShareCompareRsiSiteidList;
    payload.carsShareCompareRsiOrgidList = carsShareCompareRsiOrgidList;
    payload.displayRsiClubChatEnabled = displayRsiClubChatEnabled;
    payload.displayRsiClubChatRsiSiteidList = displayRsiClubChatRsiSiteidList;
    payload.displayRsiClubChatRsiOrgidList = displayRsiClubChatRsiOrgidList;
    payload.excludeContactInformationRsiSiteidList = excludeContactInformationRsiSiteidList;
    payload.excludeContactInformationRsiOrgidList = excludeContactInformationRsiOrgidList;
    payload.googleTagManagerCode = googleTagManagerCode;
    payload.privacyPolicyExclusiveOrgidList = privacyPolicyExclusiveOrgidList;
    payload.modernHomeTemplateOrgidList = modernHomeTemplateOrgidList;
    payload.modernHomeTemplateSiteidList = modernHomeTemplateSiteidList;
    payload.displayPublicPriceB2CSearch = displayPublicPriceB2CSearch;
    payload.displayPublicPriceB2CDetails = displayPublicPriceB2CDetails;
    payload.displayPublicPriceB2CBooking = displayPublicPriceB2CBooking;
    payload.displaySupplierPublicPriceB2C = displaySupplierPublicPriceB2C;
    payload.displayShareCompareHotels = displayShareCompareHotels;
    payload.displayShareCompareCondos = displayShareCompareCondos;
    payload.displayShareCompareCars = displayShareCompareCars;
    payload.displayMergeHistoryTabsRsi = displayMergeHistoryTabsRsi;
    payload.displayMergeHistoryTabsRsiOrgidList = displayMergeHistoryTabsRsiOrgidList;
    payload.displayMergeHistoryTabsRsiSiteidList = displayMergeHistoryTabsRsiSiteidList;
    payload.enableWalletReward = enableWalletReward;
    payload.disableNearbyResults = disableNearbyResults;
    payload.rewardWalletPriority = rewardWalletPriority;
  }

  return payload;
};

export const getIsDisableSignIn = (account: IAccount): boolean =>
  JSON.parse(
    getPreferenceFromAccount(account, DISABLE_SIGN_IN_FIELD_NAME, 'false'),
  );

export const getDisableSignInRedirect = (account: IAccount): string =>
  getPreferenceFromAccount(account, DISABLE_SIGN_IN_REDIRECT_FIELD_NAME);
